(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeListController', BridgeListController);

    BridgeListController.$inject = ['$scope', '$rootScope', '$translate', '$stateParams', '$sce', '$q', '$timeout', '$filter', 'BridgeService', 'RequestService', 'Authenticate', 'OltService'];

    function BridgeListController($scope, $rootScope, $translate, $stateParams, $sce, $q, $timeout, $filter, BridgeService, RequestService, Authenticate, OltService) {
        var vm = this;

        if (!Authenticate.hasPermission('bridgeList')) {
            return;
        }

        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 
        
        var bridgeListFull = [];
        vm.bridgeList = [];
        vm.portType = {GE1: 'ETH', GE10: '10GE', GPON: 'Gpon'};

        vm.listTipo = [{value: 'omci'},{value: 'pppoe'},{value: 'telefonia'},{value: 'router'}];
        vm.tipo = '';
        vm.nome = '';

        vm.requestRunning = false;
        var hasError = false;
        vm.view = {};
        vm.view.tooltip = '';

        var searchParams = null;
        vm.searchVlan = '';

        vm.addBridge = addBridge;
        vm.configBridge = configBridge;
        vm.deleteBridge = deleteBridge;
        vm.isBridgeListEmpty = isBridgeListEmpty;
        vm.hasErrorList = hasErrorList;
        vm.toggle = toggle;
        vm.isVlanVisible = isVlanVisible;
        vm.getData = getData;
        vm.getBridgeList = getBridgeList;
        vm.bridgeIdPreparedForUpdate = 0;

        // Action Functions
        function addBridge() {
            BridgeService.addBridgeModalConstructor($scope);
        }

        function configBridge(bridgeId) {
            vm.bridgeIdPreparedForUpdate = bridgeId;
            BridgeService.editBridgeModalConstructor($scope, bridgeId);
        }

        function deleteBridge(bridgeItem) {
            var dataAction = {
                action: 'delete',
                methodService: 'deleteBridge',
                methodDependency: function (bridgeItem) {
                    return checkGtp(bridgeItem);
                },
                methodExtra: function (bridgeData) {
                    bridgeListFull.forEach(function (bridge, index, array) {
                        if (bridge.id == bridgeData.id) {
                            array.splice(index, 1);
                        }
                    });
                    getBridgeList()
                }
            };
            BridgeService.confirmationModalConstructor(bridgeItem, dataAction)
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addBridge').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getBridgeList() {
            RequestService.cancelRequests(['bridges']);
            getData(vm.currentPage);
        }

        function isBridgeListEmpty() {
            return !vm.requestRunning && !vm.bridgeList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.bridgeList.length && hasError;
        }

        function isVlanVisible() {
            return !bridgeListFull.length || vm.requestRunning || vm.hasErrorList();
        }

        function toggle(id) {
            vm.bridgeList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }
        
        function updateList() {
            //vm.bridgeList = $filter('filter')(bridgeListFull, {vlan: vm.searchVlan ? vm.searchVlan : (vm.searchVlan === 0 ? vm.searchVlan : '')});
            getBridgeList();
        }

        var cancelListenerAdd = $rootScope.$on('bridgeAddSuccess', function (event, data) {
            if (vm.searchVlan) {
                vm.searchVlan = '';
            }

            data.forEach(function (item) {
                bridgeListFull.push(parseBridge(item));
            });

            getBridgeList()
        });
        $rootScope.$on('$destroy', cancelListenerAdd);

        var cancelListenerEdit = $rootScope.$on('bridgeUpdateSuccess', function (event, data) {
            data.forEach(function (bridgeUpdated) {
                var isBridgeOnList = false;

                bridgeListFull.forEach(function (bridgeFromList, index) {
                    if (bridgeFromList.id == vm.bridgeIdPreparedForUpdate) {
                        isBridgeOnList = true;
                        bridgeListFull[index] = parseBridge(bridgeUpdated);
                        vm.bridgeIdPreparedForUpdate = 0;
                    }

                });

                if (!isBridgeOnList) {
                    bridgeListFull.push(parseBridge(bridgeUpdated));
                }
            });

            updateList();
        });
        $rootScope.$on('$destroy', cancelListenerEdit);

        function checkGtp(item) {
            var deferred = $q.defer();
            if (!item.onuId) {
                deferred.resolve(true);
            } else {
                OltService.getOlt(item.oltId)
                        .then(function (data) {
                            if (!data.gtpCpeMgrId && data.model == "Intelbras8820i") {
                                OltService.gtpCpeMgrModalConstructor(item.oltId, $scope, true);
                                deferred.resolve(false);
                            }
                            deferred.resolve(true);
                        });
            }
            return deferred.promise;
        }

        // Request Callbacks
        function successListBridge(data) {

            setRequestEnd();
            //bridgeListFull = data.map(parseBridge);
            bridgeListFull = data.data.content.map(parseBridge);
            vm.totalCount = data.data.totalElements; // total data count.

            vm.bridgeList = angular.copy(bridgeListFull);
            hasError = false;


            for (var i = 0; i < data.length; i++) {

                if (data[i].serviceType == 'VOICE') {


                    for (var j = 0; j < data[i].fxs.length; j++) {


                        var fxs = data[i].fxs[j].dialNumber;
                    }
                }
            }
        }        
        
        function errorListBridge() {
            setRequestEnd();
            hasError = true;
        }

        function parseBridge(item) {
            item.status = item.status.toLowerCase();
            item.type = item.type.toLowerCase();
            item.vlanMode = item.vlanMode.toLowerCase();
            item.vlan = item.vlan == null ? '--' : item.vlan;
            item.slan = item.slan == null ? '--' : item.slan;
            return item;
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        if (searchParams && vm.searchVlan) {
            var data = angular.copy(searchParams);
            data.vlan = (vm.searchVlan);                
        } else if (vm.searchVlan) {
            var data = {
                vlan : vm.searchVlan
            }
            searchParams = data;
            vm.searchVlan = '';
        }

        function getData(pageNumber) {
            setRequestStart();
            var data;
            vm.currentPage = pageNumber;   
            if (searchParams) {
                data = angular.copy(searchParams);
                data.currentPage = (vm.currentPage - 1);
            } else {
                data = {
                    currentPage : (vm.currentPage - 1)
                }
            }
            if (vm.tipo != '') {
                data.tipo = vm.tipo.value;
            }
            if (vm.nome != '') {
                data.bridgeName = vm.nome;
            }
            if (vm.searchVlan) {
                data.vlan = (vm.searchVlan);                
            }    
            
            vm.bridgeList = [];
            BridgeService.listBridgePages(data).then(successListBridge).catch(errorListBridge);
        }

        function initialize() {
            if (!$stateParams.id) {
                getBridgeList();
            }
            getTooltip();
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getBridgeList();
        });

        $scope.$on('$viewContentLoaded', function () {
            $timeout(initialize);
        });

        $scope.$on('clearFilter', function () {
            vm.tipo = '';
            vm.nome = '';
            vm.searchVlan = '';
            searchParams = null;
            getBridgeList();
        });
    }
})();
